module.exports = __webpack_public_path__ + "img/27.5d07d205.jpg";